import React from 'react'
import { Setting3 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import TableSettingsModal from './TableSettingsModal'

import useStyles from './styles'

const TableSettings = ({ id }) => {
  const theme = useTheme()

  const [open, setOpen] = React.useState(false)

  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <Setting3
          size={theme.size.base}
          color={theme.palette.primary.main}
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            setOpen(true)
          }}
        />
      </div>

      {open && <TableSettingsModal id={id} onClose={() => setOpen(false)} />}
    </>
  )
}

export default TableSettings
